/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiView = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.685 17.124 5.905 6.946h1.96l2.716 8.008 2.716-8.008h1.89l-3.78 10.178H9.685zm6.45-8.848v-1.4h1.946v1.4h-1.946zm.252 8.848v-6.118l-.742-.546v-.7h2.45v7.364h-1.708z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiView as PmiView };
